import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "card h-100" }
const _hoisted_3 = { class: "card-body d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = { class: "card-title h3 mb-0" }
const _hoisted_5 = { class: "card-footer last-updated-text text-muted text-center small" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "card h-100" }
const _hoisted_8 = { class: "card-body d-flex flex-column justify-content-center align-items-center" }
const _hoisted_9 = { class: "card-title h3 mb-0" }
const _hoisted_10 = { class: "card-footer last-updated-text text-muted text-center small" }
const _hoisted_11 = { class: "col d-none" }
const _hoisted_12 = { class: "card h-100" }
const _hoisted_13 = { class: "card-body d-flex flex-column justify-content-center align-items-center" }
const _hoisted_14 = { class: "card-title h3 mb-0" }
const _hoisted_15 = { class: "card-footer last-updated-text text-muted text-center small" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "card h-100" }
const _hoisted_18 = { class: "card-body d-flex flex-column justify-content-center align-items-center" }
const _hoisted_19 = { class: "card-title h3 mb-0" }
const _hoisted_20 = { class: "card-footer last-updated-text text-muted text-center small" }
const _hoisted_21 = { class: "card h-100" }
const _hoisted_22 = { class: "card-body d-flex flex-row justify-content-center align-items-center text-nowrap" }
const _hoisted_23 = { class: "card-title h3 mb-0" }
const _hoisted_24 = ["data-bs-content"]
const _hoisted_25 = { class: "card-footer last-updated-text text-muted text-center small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row row-cols-1 row-cols-sm-2 g-4 justify-content-center", `row-cols-xl-${_ctx.cols}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "card-header text-truncate" }, [
          _createElementVNode("i", { class: "fas fa-arrow-trend-up text-red me-2" }),
          _createElementVNode("span", null, "Ganancias Totales")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, "G$ " + _toDisplayString(_ctx.total), 1)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.totalDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "card-header text-truncate" }, [
          _createElementVNode("i", { class: "fas fa-wallet me-2" }),
          _createElementVNode("span", null, "Comisiones Pagadas")
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h6", _hoisted_9, "G$ " + _toDisplayString(_ctx.pending), 1)
        ]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.pendingDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "card-header text-truncate" }, [
          _createElementVNode("i", { class: "fab fa-bitcoin me-2" }),
          _createElementVNode("span", null, "Total Retirado")
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h6", _hoisted_14, "G$ " + _toDisplayString(_ctx.paid), 1)
        ]),
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.paidDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "card-header text-truncate" }, [
          _createElementVNode("i", { class: "fas fa-piggy-bank me-2" }),
          _createElementVNode("span", null, "Bonos Recibidos")
        ], -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("h6", _hoisted_19, "G$ " + _toDisplayString(_ctx.paid), 1)
        ]),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.paidDate), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["col", `d-${parseFloat(_ctx.toBeProcessed) != 0 ? 'block' : 'none'}`])
    }, [
      _createElementVNode("div", _hoisted_21, [
        _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "card-header text-truncate" }, [
          _createElementVNode("i", { class: "far fa-clock text-warning me-2" }),
          _createElementVNode("span", null, "Comisiones Pendientes")
        ], -1)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("h6", _hoisted_23, "G$ " + _toDisplayString(_ctx.toBeProcessed), 1),
          _createElementVNode("button", {
            class: _normalizeClass([{
              'd-none':
                parseFloat(_ctx.toBeProcessed) >=
                parseFloat(_ctx.getSystemConfig.displayedMinimumPaymentAmount),
            }, "btn"]),
            "data-bs-toggle": "popover",
            "data-bs-content": _ctx.minimumAmountMessage,
            "data-bs-trigger": "focus",
            "data-bs-html": "true",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
            ref: "minimumAmountPopup"
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-sm fa-fw text-warning" }, null, -1)
          ]))], 10, _hoisted_24)
        ]),
        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.toBeProcessedDate), 1)
      ])
    ], 2)
  ], 2))
}